export default "__VITE_ASSET__B2do8itc__"